/**
 * DUEL-V3-P1: recovery made readable. Each frame the recovery of the two fighters (rules: duelRecoveryOf) is fed to the
 * figure pose (hitReact.ts: a slump, a whiff overextended) and to the tell (duelRing.recov: the foe's "ช่องว่าง!" word,
 * ring and brackets in cyan). Picture only.
 */
import { duelRecoveryOf } from '@nine/shared';
import { registerRenderPass } from './registry';
import { duelRing } from './duelRing';
import { hitReactRecovery } from '../hitReact';

registerRenderPass({
  id: 'duelRecoveryTell',
  layer: 'ground',
  order: 201,
  draw({ world: w }) {
    const sys = duelRecoveryOf(w);
    const ids = [duelRing.me, duelRing.foe];
    for (let i = 0; i < 2; i++) {
      const info = duelRing.on && sys && ids[i]! >= 0 ? sys.info(ids[i]!) : null;
      hitReactRecovery(ids[i]!, info);
      duelRing.recov[i] = info ? info.len - info.t : 0;
    }
  },
});
